import { useConnect } from '@lore/query-connect';
import { event_networkId } from '../../../../utils/query-helpers';

export default function useEventInvitationsCreated(network, timestamp) {
  return useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          ...event_networkId(network),
          createdAt: {
            $gte: timestamp.start,
            $lte: timestamp.end
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
